export function createEveryNTicksRunner(onEveryNTicks?: { n: number; fn: () => void }): {
  reset: () => void;
  onTick: () => void;
} {
  let tickCount = 0;

  return {
    reset(): void {
      tickCount = 0;
    },
    onTick(): void {
      if (!onEveryNTicks || onEveryNTicks.n <= 0) return;
      tickCount++;
      if (tickCount % onEveryNTicks.n !== 0) return;
      try {
        onEveryNTicks.fn();
      } catch {
        /* ignore */
      }
    },
  };
}
